import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class EcallDetailService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  downloadServiceReport(serviceReportId): Observable<any> {
    // return Observable.of(1).delay(3000);
    const url = this.urlPrefix + `forms/service-report/${serviceReportId}/pdf`;
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

  getDetail(id): Observable<any> {
    const url = this.urlPrefix + 'e-calls/' + id;
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-detail/ecall-detail.service.ts